var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheckCircle, faClock, faExclamationCircle, faExclamationTriangle, faLink, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BAlert, BButton } from "bootstrap-vue";
import { computed } from "vue";
import {} from "./models/exportRecordModel";
import Heading from "@/components/Common/Heading.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ExportRecordDetails',
    props: {
        record: null,
        objectType: null,
        actionMessage: { default: undefined },
        actionMessageVariant: { default: "info" }
    },
    emits: ["onActionMessageDismissed", "onReimport", "onDownload", "onCopyDownloadLink"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faCheckCircle, faClock, faExclamationCircle, faExclamationTriangle, faLink);
        const title = computed(() => (props.record.isReady ? `Exported` : `Export started`));
        const preparingMessage = computed(() => `Preparing export. This may take some time depending on the size of your ${props.objectType}`);
        function reimportObject() {
            return __awaiter(this, void 0, void 0, function* () {
                emit("onReimport", props.record);
            });
        }
        function downloadObject() {
            emit("onDownload", props.record);
        }
        function copyDownloadLink() {
            emit("onCopyDownloadLink", props.record);
        }
        function onMessageDismissed() {
            emit("onActionMessageDismissed");
        }
        return { __sfc: true, props, emit, title, preparingMessage, reimportObject, downloadObject, copyDownloadLink, onMessageDismissed, faCheckCircle, faClock, faExclamationCircle, faExclamationTriangle, faLink, FontAwesomeIcon, BAlert, BButton, Heading, LoadingSpan };
    }
});
